<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

  <v-app-bar
      app
      color="grey lighten-4"
    >
          <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://conciergepad-images.s3.amazonaws.com/concierge_logo.png"
          transition="scale-transition"
          width="250"
        />
        </div>




  </v-app-bar>
  
    <div>
    <v-alert
      v-model="alert"
      type="success"
      border="left"
      close-text="Close Alert"
      dismissible
    >
     Please check your email inbox and look for the update registration link.
    </v-alert>

  </div>


  <v-card
    class="mx-auto"
    max-width="500"
  >
  <v-card-text>
 <div class="text--primary">
        Please put in the username/email that you signed up with and we will send you a rest password link.
      </div>
  </v-card-text>
    <v-card-text>
      

    <v-text-field
      v-model="username"
      label="Email"
      solo
      outlined
      @keyup="uppercase"
    ></v-text-field>
    <v-alert type="success" v-model="validCode">
      Valid Email.
    </v-alert>

     <v-alert type="error" v-model="invalidCode">
     Email does not exist or is invalid.
    </v-alert>

    </v-card-text>





    <v-alert type="error" v-model="passwordAlert">
      {{message}}
    </v-alert>

    <v-card-actions>
      <v-btn
      :disabled="valid"
      color="success"
      class="mr-4"
      @click="updateUser"
    >
      Reset Password
    </v-btn>
    </v-card-actions>

  </v-card>

   
  </v-form>
</template>


<script>

  import axios from 'axios';

  export default {
    data: () => ({
      passwordAlert: false,
      message: '',
      alert: false,
      pId: '',
      username: '',
      password: '',
      reTypePassword: '',
      valid: true,
      validCode: false,
      invalidCode: false,
      items: [],
      name: '',
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    }),

    mounted: function() {
      
      console.log("GETTING PARAMETER");
     

      this.pId = this.$route.query.id;

      console.log(this.pId);

      console.log(this.$route.query);

   
  },

    methods: {


    uppercase() {

        console.log("HERE");

        if (this.username.includes("@") && this.username.includes(".")) {

          this.checkUser();

        }
        else {

             this.valid = true;
             this.validCode = false;
             this.invalidCode = false;

        }
    },

    checkUser:function() {

      axios.get('https://api.conciergepadedu.com/api/Users/CheckUser/' +  this.username).then(response => {

      if (response.data.error) {

        this.validCode = false;
        this.invalidCode = true;

      } else {

        console.log(response.data);
        

        //successful
        this.validCode = true;
        this.invalidCode = false;

        this.valid = false;




        }

        }).catch(error => {

            console.log(error.response)

            this.validCode = false;
            this.invalidCode = true;

        });

    },

      getUserId:function(inId) {

      axios.get('https://api.conciergepadedu.com/api/Users/GetUserReg/' +  inId).then(response => {

      if (response.data.error) {

        this.validCode = false;
        this.invalidCode = true;

      } else {

        console.log(response.data);
        

        //successful
        this.validCode = true;
        this.invalidCode = false;

        this.items = response.data;

        console.log("////////////////////////////////////");
        console.log(this.items.primarY_ACCOUNT);

        this.username = this.items.username;




        }

        }).catch(error => {

            console.log(error.response)

            this.validCode = false;
            this.invalidCode = true;

        });

    },
    updateUser() {

    axios.get('https://api.conciergepadedu.com/api/Users/LostPasswordEmail/' +  this.username).then(response => {

      if (response.data.error) {

        this.$alert("Not Sent Successfully","Lost Password","danger");

        this.invalidCode = false;
        this.validCode = false;

      } else {

        console.log(response.data);
        

        this.$alert("Email successfully sent to reset password","Lost Password","success");

        this.valid = true;
        this.username = '';
        this.invalidCode = false;
        this.validCode = false;




        }

        }).catch(error => {

           console.log(error.response)

           this.invalidCode = false;
           this.validCode = false;
           this.$alert("Not Sent Successfully","Lost Password","danger");

        });

      

    },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>